import { Link } from "react-router-dom";
import { Instagram, Mail, Phone } from "lucide-react";
import { NAV_LINKS } from "@/components/layout/Header";
import { CONTACT_INFO } from "@/data/demo";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-[#050505] border-t border-white/5 overflow-hidden">
      <div className="px-6 md:px-12 lg:px-24 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <img
              src="/logo-3m.png"
              alt="3M Match Pro"
              className="h-12 w-auto object-contain"
            />
            <p className="mt-4 text-white/60 text-sm leading-relaxed max-w-sm">
              Organisation de stages de football et de matchs amicaux professionnels et semi-professionnels.
              L'expérience du jeu, l'exigence du haut niveau.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={CONTACT_INFO.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-instagram"
                aria-label="Instagram 3M Match Pro"
                className="w-10 h-10 flex items-center justify-center border border-white/15 text-white/50 hover:border-gold hover:text-gold transition-colors"
              >
                <Instagram size={17} />
              </a>
              <span className="text-xs text-white/40">@3m.matchpro</span>
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold mb-5">Navigation</p>
            <nav className="grid grid-cols-2 gap-x-6 gap-y-3">
              {NAV_LINKS.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  data-testid={`footer-link-${link.to === "/" ? "accueil" : link.to.slice(1)}`}
                  className="text-sm text-white/60 hover:text-gold transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold mb-5">Contact</p>
            <div className="space-y-3 text-sm text-white/60">
              <p className="flex items-center gap-3">
                <Mail size={15} className="text-gold/70 shrink-0" />
                <a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-gold transition-colors">
                  {CONTACT_INFO.email}
                </a>
              </p>
              {CONTACT_INFO.telephones.map((t) => (
                <p key={t.number} className="flex items-center gap-3">
                  <Phone size={15} className="text-gold/70 shrink-0" />
                  <a href={`tel:${t.number.replace(/\s/g, "")}`} className="hover:text-gold transition-colors">
                    {t.name} — {t.number}
                  </a>
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="px-6 md:px-12 lg:px-24 overflow-hidden select-none" aria-hidden="true">
        <p
          className="font-display text-[18vw] leading-[0.8] text-center text-transparent whitespace-nowrap translate-y-[12%]"
          style={{ WebkitTextStroke: "2.5px rgba(212, 175, 55, 0.85)" }}
        >
          3M MATCH PRO
        </p>
      </div>

      <div className="border-t border-white/5">
        <div className="px-6 md:px-12 lg:px-24 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40">
          <p>© 2026 3M MATCH PRO — Tous droits réservés</p>
          <div className="flex items-center gap-6">
            <Link to="/mentions-legales" data-testid="footer-link-mentions-legales" className="hover:text-gold transition-colors">
              Mentions légales
            </Link>
            <Link
              to="/politique-confidentialite"
              data-testid="footer-link-politique-confidentialite"
              className="hover:text-gold transition-colors"
            >
              Politique de confidentialité
            </Link>
            <span className="text-white/25 cursor-default" title="Gestion des cookies — à venir">
              Cookies
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
